import { render, staticRenderFns } from "./SidebarNotificationsAgent.vue?vue&type=template&id=2644441c&"
import script from "./SidebarNotificationsAgent.vue?vue&type=script&lang=js&"
export * from "./SidebarNotificationsAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports